"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseContractErrorDto = exports.ContractError = exports.CONTRACT_ERROR_CODES = void 0;
exports.CONTRACT_ERROR_CODES = [
    'invalid-request',
    'authentication-required',
    'verification-required',
    'collection-not-found',
    'membership-required',
    'role-required',
    'collection-unavailable',
    'operation-conflict',
    'capacity-exceeded',
    'insufficient-credits',
    'confirmation-required',
    'paid-transfer-not-supported',
    'provider-reconciliation',
    'rate-limited',
    'transient-failure',
];
class ContractError extends Error {
    constructor(code, message, retryable = false, retryAfter) {
        super(message);
        this.code = code;
        this.retryable = retryable;
        this.retryAfter = retryAfter;
        this.name = 'ContractError';
    }
}
exports.ContractError = ContractError;
const parseContractErrorDto = (value) => {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        throw new Error('Contract error must be an object.');
    }
    const input = value;
    if (!values_1.SUPPORTED_CONTRACT_VERSIONS.includes(input.contractVersion)) {
        throw new Error('Contract error version is unsupported.');
    }
    if (typeof input.code !== 'string' ||
        !exports.CONTRACT_ERROR_CODES.includes(input.code)) {
        throw new Error('Contract error code is unsupported.');
    }
    if (typeof input.message !== 'string' || !input.message) {
        throw new Error('Contract error message is required.');
    }
    if (typeof input.retryable !== 'boolean') {
        throw new Error('Contract error retryable flag is required.');
    }
    if (input.retryAfter !== undefined && typeof input.retryAfter !== 'string') {
        throw new Error('Contract error retryAfter must be a string.');
    }
    return {
        contractVersion: input.contractVersion,
        code: input.code,
        message: input.message,
        retryable: input.retryable,
        retryAfter: input.retryAfter,
    };
};
exports.parseContractErrorDto = parseContractErrorDto;
const values_1 = require("./values");
